var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('a-spin',_vm._b({staticClass:"full-width full-height",attrs:{"size":"large"}},'a-spin',_vm.loadingProps,false),[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }